import logo from './logo/logo.png';
import logoFull from './logo/logo_full.png';

const config: ThemeConfig = {
  hideInformationPopup: false,
  useInterfaceLanguageForButtons: false,
  logo: {
    default: logo,
    full: logoFull,
    altText: 'Sillabi logo',
  },
};

export default config;
